import React from "react";

interface Props {
  label: string;
  selected: boolean;
  onToggle: () => void;
}

const TogglePill: React.FC<Props> = ({ label, selected, onToggle }) => (
  <button
    type="button"
    className={`toggle-pill${selected ? " toggle-pill-selected" : ""}`}
    onClick={onToggle}
    aria-pressed={selected}
  >
    <span className="toggle-pill-label">{label}</span>
    <span className="toggle-pill-icon" aria-hidden="true">
      {selected ? "✓" : "+"}
    </span>
  </button>
);

export default TogglePill;
